import React from "react";
import {MinCartHandler} from "../actions/min_cart";
import SweetAlert2 from 'react-sweetalert2';
import moment from 'moment';
import { replace, size } from "lodash";
import { ProductAddToCart } from "./ProductAddToCart";
import { ProductOutOfStock } from "./ProductOutOfStock";
import { ProductInCart } from "./ProductInCart";
import { SessionSelectItem } from "./SessionSelectItem";

export class ProductCardActionButton extends React.Component<any, any> {
	private minCart:MinCartHandler;

	constructor(props:any) {
		super(props);
		this.minCart = new MinCartHandler();

		var sessions:any = props.product.sessions.map((session:any) => {
            return {
                ...session,
                selected: !(session.optional === '1'),
                quantity: Number.parseInt(session['default-quantity'])
            }
        });

		this.state = {
            swal: {
				title: 'SELECT THE DESIRED SESSIONS:',
				showConfirmButton: false,
				text: '',
                customClass: {
                    // container: 'my-swal',
                    popup: 'swal-session-cart-popup',
                    // header: 'my-swal-header',
                    title: 'swal-session-cart-title',
                    // closeButton: 'my-swal-close-button',
                    // icon: 'my-swal-icon',
                    // image: 'my-swal-image',
                    // content: 'my-swal-content',
                    // input: 'my-swal-input',
                    // actions: 'my-swal-actions',
                    // confirmButton: 'my-swal-confirm-button',
                    // cancelButton: 'my-swal-cancel-button',
                    // footer: 'my-swal-footer'
                },
				didClose: () => {
					this.setState((prevState:any) => {return {swal: {...prevState.swal, show: false}}});
				},
			},
			sessions,
			buttonClicked: undefined,
            buttonClickedEvent: undefined,
            qty_in_cart: Number.parseInt(props.product.curr_qnt),
        }
	}

    addToCartHandler = (e:any) => {
        setTimeout(() => {
            this.minCart.forceUpdatedCart();
        }, 1000);
    }

    render(): React.ReactNode {
        var product = this.props.product;

        var retorno = [];
        retorno.push(<SweetAlert2 key="swal" {...this.state.swal}></SweetAlert2>);


        if (product.stock_status !== 'instock') { // Out of stock
            retorno.push(<ProductOutOfStock key='outstock' className='outstock' product_id={product.product_id} add_to_btn_txt={product.product_text.product_stock} />);
            return retorno;
        }

        if (!product.can_purchase) { // Membership required for purchase to be possible
            retorno.push(<a href='#' onClick={this.showMembershipRequirements} className='added_to_cart wc-forward action_button test3' rel='nofollow'>{"Membership required"}</a>);
            return retorno;
        }

        if (product.purchased) { // Product purchased
            retorno.push(<a href='#' data-enroll-user={product.product_id} className='button product_type_simple enroll_now' rel='nofollow'>{product.product_text.product_enroll}</a>);
            return retorno;
        }

        if (product.sessions.length > 0) { // Product at least one sesion
            retorno.push(<a href='#' onClick={this.checkForMultipleSessions} data-enroll-user={product.product_id} className='action_button button product_type_simple enroll_now' rel='nofollow'>{product.product_text.product_add_to_cart}</a>);
            return retorno;
        }

        if ((this.state.qty_in_cart ?? product.curr_qnt) < product.max_qnt_cart) { // Exceeded Max Quantity
            retorno.push(
                    <ProductAddToCart 
                        key='add_to_cart' 
                        clickHandler={this.addToCart} 
                        max_qnt_cart={product.max_qnt_cart} 
                        curr_qnt={(this.state.qty_in_cart ?? product.curr_qnt)} 
                        product_id={product.product_id} 
                        product_text={product.product_text} 
                        btn_mode="add_to_cart" 
                    />
                );
        } else {
            retorno.push(
                <span 
                    key='max_qty_warn' 
                    style={{"visibility": ((this.state.qty_in_cart > 1) ? "visible" : "hidden")}} 
                > 
                    {`Item limit reached (${product.max_qnt_cart})`} 
                </span>
            );
        }
        
        retorno.push(
            <ProductAddToCart 
                key='view_cart' 
                style={{"visibility": ((this.state.qty_in_cart >= 1) ? "visible" : "hidden")}} 
                clickHandler={this.checkForMultipleSessions} 
                max_qnt_cart={product.max_qnt_cart} 
                curr_qnt={product.curr_qnt} 
                product_id={product.product_id} 
                product_text={product.product_text} 
                btn_mode="view_cart" 
            />
        );

        return <div style={{flex: 2}}> {retorno} </div>;
	}
}